import { reactive } from 'vue'

let appState

export default function useAppState () {
  return appState || (appState = reactive({
    modal: null,
    toasts: [],
    hardRolls: false
  }))
}
